import { Button } from '@uswitch/spark'
import { UswArrowLargeRight } from '@uswitch/spark-icons/usw'

import LandingForm from '../landing-form/form-types/interactive'

import { ModalContainer } from './index.jsx'
import * as styles from './styles'

/**
 * PostcodeModal
 * Simple postcode Modal Form with bindings for the Title & Body.
 *
 * data-modal-target='title'  - <div />
 * data-modal-target='body'   - <p />
 */
export const PostcodeModal = ({ id = 'postcode' }) => (
  <ModalContainer id={id}>
    <div data-modal-target='title' sx={styles.title}>
      Check what's in your area
    </div>
    <p data-modal-target='body' sx={styles.body}>
      You're just a few steps away from seeing our best deals where you live.
    </p>

    <LandingForm variant='Modal' ctaText='Find deals in my area' />
  </ModalContainer>
)

/**
 * DealModal
 * Modal for click outs of deals
 */
export const DealModal = () => (
  <ModalContainer id='deal'>
    <div sx={styles.title}>This deal may not be in your area</div>
    <p sx={styles.body}>Add your postcode and we'll check what you can get where you live</p>

    <div sx={styles.inputForm}>
      <LandingForm variant='Modal' ctaText='Check availability' />
    </div>

    <div data-action='click->modal#hide:stop:prevent click->modal#clickout'>
      <Button
        data-cypress-id='deal-modal-click-out'
        variant='secondary'
        type='button'
        fullWidth
        rightIcon={<UswArrowLargeRight strokeWidth={3} />}
        sx={styles.dealButton}
      >
        That's OK, take me to this deal
      </Button>
    </div>
  </ModalContainer>
)
